import { Component } from '@angular/core';

import { TableCellState } from '../../table.state';

@Component({
  selector: 'app-cell-link',
  templateUrl: './cell-link.component.html',
  styleUrls: ['./cell-link.component.scss'],
})
export class CellLinkComponent extends TableCellState {}
